export const colors = {
    white: '#fff',
    'ui-100': '#f8f7fa',
    'ui-200': '#eeedf2',
    'ui-300': '#dbdae3',
    'ui-500': '#a9a8b3',
    'ui-550': '#94949e',
    'ui-600': '#6f7287',
    'ui-700': '#585163',
    'ui-800': '#39364f',
    'ui-900': '#1e0a3c',
    'ui-error': '#c5162e',
    'ui-progress': '#4be1a0',
    control: '#3659e3',
    'control--hover': '#3d64ff',
    'control--focus': '#3d64ff',
    'control--active': '#304fc9',
    'ui-orange': '#f05537',
    'ui-orange--hover': '#d6472b',
    'ui-orange--active': '#bd3a20',
    'primary-brand': '#d1410c',
    'primary-brand--hover': '#f05537',
    'primary-brand--active': '#c23c0c',
    success: '#0d8547',
    'success-fill-color': '#f1fdf8',
    'success-stroke-color': '#4be1a0',
    'danger-fill-color': '#fdeff1',
    'danger-stroke-color': '#e02e46',
    'warning-fill-color': '#fffcef',
    'warning-stroke-color': '#ffde3b',
    'info-fill-color': '#f8f7fa',
    'info-stroke-color': '#6f7287',
    'info-icon-container-color': '#4b4d63',
    'opportunity-stroke-color': '#3659e3',
    'opportunity-fill-color': '#ebeffd',
    'heading-secondary': '#3A3247',
    'heading-primary': '#261B36',
    'body-secondary': '#716B7A',
    'surface-hover': '#F8F7FA',
    'grey-light': '#39364F',
    'grey-secondary-light': '#F8F7FA',
    'blue-light': '#EBEFFD',
    'blue-accent': '#3659E3',
    'dark-grey': '#3A3247',
};
